import { axiosjs, post } from "../../static/axios";
import { Dialog } from 'vant';
export class App{
  static generateQRcode(data){
    return post('/app-order/generateQRcode',data)
  }
  //获取地市列表
  static queryCom(data){
    return post('/ap-area/queryCom',data)
  }
  //查询我的推广
  static getPromotion(data){
    return post('/app-promotion/getPromotion',data)
  }
  //查询头像列表
  static getHeadpicture(data){
    return post('/app-register/getHeadpicture',data)
  }
  //司机保存消息推送距离接口
  static saveReceptDistance(data){
    return post('/app-user/saveReceptDistance',data)
  }
  //司机查询推送距离接口
  static queryPersonalData(data){
    return post('/app-user/queryPersonalData',data)
  }
}
export class MapUtil {
  static baiduLocation() {
    return new Promise((resolve, reject) => {
      AMap.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          timeout: 10000,
        });

        geolocation.getCurrentPosition(
          (status, result) => {
            console.log('获取位置', status, result);
            if (status === 'complete') {
              resolve(result); // 成功时返回位置信息
            } else {
              reject(new Error('获取位置失败')); // 失败时返回错误
            }
          }
        );
      });
    });
  }
  static async getPermissions(type){
    try {
      let message =''
      if (type ==='CAMERA') {
        message ='申请相机权限用于提供拍照服务，申请图片权限用于展示图片'
      }else if (type ==='LOCATION') {
        message ='申请定位权限以便您输入地址和匹配最适合的司机或者订单,建议配置为始终允许，方便调度查看订单运行情况'
      } else if (type ==='BACKGROUND_LOCATION') {
        message ='申请定位权限以便您输入地址和匹配最适合的司机或者订单,建议配置为始终允许，方便调度查看订单运行情况'
      } else if (type ==='STORAGE') {
        message ='请允许使用存储权限，否则无法上传下载图片'
      } else if (type ==='CALLPHONE') {
        message ='请允许使用电话权限，否则无法拨打电话'
      } else if (type ==='NLSERVICE') {
        message ='请允许使用通知权限，否则无法获取进度通知'
      }else{
        throw new Error("请选择正确的权限类型");  
      }
      if (window.CSDK._isWebViewAvailable()) {
        let hasPermission = await CSDK.hasePermissions(type)
        console.log('hasePermissions权限===', hasPermission);
        if (!hasPermission) {
          if (type !=='BACKGROUND_LOCATION') {
            await Dialog.confirm({
              title: '权限使用说明',
              message: message,
           })
          }
          let requestPermissions = await CSDK.requestPermissions({ params: type })
          console.log('requestPermissions权限===', requestPermissions);
          if (requestPermissions === '0') {
            await Dialog.confirm({
              title: '温馨提示',
              message: '获取授权失败，请手动授予权限',
            })
            let toSetting =await CSDK.toSetting()
            console.log('toSetting===', toSetting);
            return false
          }else{
            if (type === 'LOCATION') {
              return await MapUtil.getPermissions('BACKGROUND_LOCATION')
            }
          }
        }
        return true
      }
      return true
    } catch (error) {
      console.error('权限申请过程中发生错误:', error);
      return false
    }
    
  }
// 新增方法：检查并请求定位权限
  static async checkAndRequestLocationPermission(shouldCheckDenied = false) {
  try {
    // 检查 WebView 是否可用
    if (!window.CSDK._isWebViewAvailable()) {
      console.warn('WebView 不可用，无法请求定位权限');
      return false;
    }
    // 检查本地存储中是否有用户拒绝权限的记录
    // 根据参数决定是否检查本地存储中是否有用户拒绝权限的记录
    if (shouldCheckDenied) {
      const locationPermissionDenied = localStorage.getItem('locationPermissionDenied');
      if (locationPermissionDenied === 'true') {
        console.log('用户之前已拒绝定位权限，不再重复申请');
        return false;
      }
    }
    // 检查是否已有定位权限
    let hasLocationPermission = await CSDK.hasePermissions('LOCATION');
    console.log('定位权限检查结果:', hasLocationPermission);

    // 检查是否已有后台定位权限
    // let hasBackgroundLocationPermission = await CSDK.hasePermissions('BACKGROUND_LOCATION');
    let hasBackgroundLocationPermission = true

    let hasAllPermissions = hasLocationPermission && hasBackgroundLocationPermission;

    if (!hasAllPermissions) {
      try {
        // 显示权限使用说明
        await Dialog.confirm({
          title: '权限使用说明',
          message: '我们需要获取您的位置信息，以便为您提供更准确的地址输入和匹配最适合的司机服务。建议配置为始终允许，方便调度查看订单运行情况。',
        });
      } catch (confirmError) {
        // 用户点击了取消按钮，记录用户拒绝权限
        console.log('用户取消了权限使用说明对话框');
        localStorage.setItem('locationPermissionDenied', 'true');
        return false;
      }

      // 请求定位权限
      if (!hasLocationPermission) {
        let locationRequestResult = await CSDK.requestPermissions({
          params: 'LOCATION',
          callback: (res) => {
            console.log('定位权限请求结果:', res);
          }
        });

        console.log('定位权限请求返回结果:', locationRequestResult);

        // 如果权限请求失败，引导用户手动设置
        if (locationRequestResult === '0') {
          localStorage.setItem('locationPermissionDenied', 'true');
          try {
            await Dialog.confirm({
              title: '权限获取失败',
              message: '无法自动获取定位权限，请前往设置页面手动开启。',
            });
          } catch (settingConfirmError) {
            // 用户点击了取消按钮，记录用户拒绝权限
            console.log('用户取消了手动设置提示');
            return false;
          }

          // 引导用户去设置页面
          let settingResult = await CSDK.toSetting();
          console.log('跳转设置页面结果:', settingResult);
          return false;
        }
      }

      // 请求后台定位权限
      if (!hasBackgroundLocationPermission) {
        let backgroundLocationRequestResult = await CSDK.requestPermissions({
          params: 'BACKGROUND_LOCATION',
          callback: (res) => {
            console.log('后台定位权限请求结果:', res);
          }
        });

        console.log('后台定位权限请求返回结果:', backgroundLocationRequestResult);

        // 如果权限请求失败，引导用户手动设置
        if (backgroundLocationRequestResult === '0') {
          localStorage.setItem('locationPermissionDenied', 'true');
          try {
            await Dialog.confirm({
              title: '权限获取失败',
              message: '无法自动获取后台定位权限，请前往设置页面手动开启。',
            });
          } catch (settingConfirmError) {
            console.log('用户取消了手动设置提示');
            return false;
          }

          // 引导用户去设置页面
          let settingResult = await CSDK.toSetting();
          console.log('跳转设置页面结果:', settingResult);
          return false;
        }
      }
    }
    // 权限获取成功，清除拒绝记录
    localStorage.removeItem('locationPermissionDenied');
    return true;
  } catch (error) {
    console.error('定位权限申请过程中发生错误:', error);
    try {
      Dialog.alert({
        title: '提示',
        message: '申请定位权限时发生错误，请稍后重试或手动在设置中开启。'
      });
    } catch (alertError) {
      // 忽略 alert 对话框的错误
    }

    // 记录用户拒绝权限（因为出现了错误）
    localStorage.setItem('locationPermissionDenied', 'true');
    return false;
  }
}
}


// WEBPACK FOOTER //
// ./src/api/app.js